import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation CreateOmiliaRequestType($model: OmiliaRequestTypeInput!) {
  createOmiliaRequestType(input: $model){
    id
    name
    requestType {
      id
    }
  }
}`;

function createOmiliaRequestType(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createOmiliaRequestType);
}

export default createOmiliaRequestType;
